import { TriviaList } from '@repo/types'

import { apiClient } from '@/api/api-client'
import StoreService from '@/store/StoreService'

import { useUpdateTriviaList } from './useUpdateTriviaList'

export function useUpdateSystemTriviaList({ listId }: { listId: string }) {
  const { triviaListService } = StoreService.getStore()

  const { queryFn: itemQueryFn, queryKey: itemQueryKey } =
    triviaListService.queries.systemTriviaList

  const { queryFn: listQueryFn, queryKey: listQueryKey } =
    triviaListService.queries.systemTriviaLists

  const mutationFn = (triviaList: TriviaList) => {
    return apiClient.adminUpdateTriviaList(triviaList)
  }

  return useUpdateTriviaList(
    mutationFn,
    itemQueryKey(listId),
    () => itemQueryFn(listId),
    listQueryKey,
    listQueryFn
  )
}
